import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import DialogTemplate from '@/_components/dialog/template/template.vue'

import Role from '@/views/Authorization/models/role'

@Component({
    inheritAttrs: false,
    name: 'RoleAdd',
    components: { DialogTemplate },
})
export default class RoleAdd extends Mixins<MixinInterface>() {
    @Prop({ required: true }) props!: any

    loading = false
    valid = false
    roleName = ''

    async submit() {
        if (this.valid) {
            this.loading = true
            let data = {
                type: 'role',
                attributes: {
                    ...(this.roleName && { name: this.roleName }),
                },
                relationships: {
                    project: {
                        data: {
                            type: 'project',
                            id: this.currentProjectId,
                        },
                    },
                },
            }

            let res = await Role.postRole(data).catch((error) => (this.loading = false))

            this.$emit('close', res)
            this.loading = true
        }
    }
}
